<template>
  <responsive-drawer-header :hasDrawer="false" :color="color" :headerBg="theme.appBar.other.bg">
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <div v-if="imageName">{{ imageName }}</div>
      <div v-else-if="galleryName">{{ galleryName }}</div>
      <div v-else>{{ $t(`gallery.subtitle.${$route.name}`) }}</div>
      <!-- <div>{{$route.name}}</div> -->
    </template>
  </responsive-drawer-header>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import index from './index.js';
import { mapState } from 'vuex';

export default {
  mixins: [common, configMixin, navigationMixin],
  components: {
    ResponsiveDrawerHeader,
  },
  data() {
    return {
      selectedGroup: 0,
    };
  },

  computed: {
    ...mapState('gallery', ['imagesById', 'galleriesById']),
    color() {
      return this.theme.appBar.other.color;
    },
    imageName() {
      let imageId = this.$route.params.imageId;
      console.debug('get imageName');
      if (!imageId) return;
      let image = this.imagesById[imageId];

      return image ? image.description : null;
    },
    galleryName() {
      let galleryId = this.$route.params.galleryId;
      if (!galleryId) return;
      let gallery = this.galleriesById[galleryId];

      return gallery ? gallery.name : null;
    },
  },
};
</script>
